import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "For Creators", href: "#creators" },
  { label: "For Brands", href: "#brands" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/70 border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="font-display text-base md:text-lg tracking-[0.32em] uppercase font-medium text-white"
        >
          OuttaRage
        </a>

        <nav className="hidden md:flex items-center gap-9" data-testid="navbar-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`navbar-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover-underline text-[13px] font-medium text-neutral-400 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="navbar-cta"
          className="hidden md:inline-flex items-center bg-white text-black hover:bg-neutral-200 hover:scale-[1.03] active:scale-[0.97] transition-all rounded-full px-5 py-2.5 text-[13px] font-medium tracking-wide"
        >
          Work With Us
        </a>

        <button
          type="button"
          data-testid="navbar-mobile-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 text-white"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`navbar-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base text-neutral-300 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="navbar-mobile-cta"
              className="mt-2 inline-flex items-center justify-center bg-white text-black rounded-full px-5 py-3 text-sm font-medium"
            >
              Work With Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
